export default "__VITE_ASSET__1c56857a__"